import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/rename.svg';
const RenameFile = () => React.createElement(IconSvg, null);
export default RenameFile;
